import {
  RENT_BOOK_LLD_DOWNLOADED,
  RENT_LLD_DOWNLOADED,
  RENT_LLD_SENDING,
  RENTS_LLD_DOWNLOADED,
  RENTS_LLD_FAILED,
  RENTS_LLD_PENDING,
  RENTS_LLD_RESET,
} from './types';
import RentsApiService from '../../services/api/RentsApiService';
import { handleError } from '../infos/actions';
import BooksApiService from '../../services/api/BooksApiService';

const rentsLldPendingAction = () => (
  {
    type: RENTS_LLD_PENDING,
  }
);
const rentLldSendingAction = () => (
  {
    type: RENT_LLD_SENDING,
  }
);
export const rentsLldResetAction = () => (
  {
    type: RENTS_LLD_RESET,
  }
);
const rentsLldFailedAction = (error) => (
  {
    type: RENTS_LLD_FAILED,
    payload: error,
  }
);
const rentsLldDownloadedAction = (data) => (
  {
    type: RENTS_LLD_DOWNLOADED,
    payload: data,
  }
);
const rentLldDownloadedAction = (data) => (
  {
    type: RENT_LLD_DOWNLOADED,
    payload: data,
  }
);
const rentLldBookDownloadedAction = (rent, data) => (
  {
    type: RENT_BOOK_LLD_DOWNLOADED,
    payload: { rent, book: data },
  }
);


export function getRents(authUserToken, role, renterId, siteLld) {
  return (dispatch) => {
    dispatch(rentsLldPendingAction());
    return RentsApiService.getRents(authUserToken, role, null, null, renterId, siteLld, true)
      .then(data => {
        dispatch(rentsLldDownloadedAction(data));
        return data;
      }).catch(error => {
        dispatch(rentsLldFailedAction(error));
        dispatch(handleError(error));
        return error;
      });
  };
}

export function closeRent(authUserToken, rent) {
  return (dispatch) => {
    dispatch(rentLldSendingAction());
    return RentsApiService.putCloseRent(authUserToken, rent.id, rent)
      .then(data => {
        dispatch(rentLldDownloadedAction(data));
        return data;
      }).catch(error => {
        dispatch(rentsLldFailedAction(error));
        dispatch(handleError(error));
        return error;
      });
  };
}

export function postRentEndInventory(authUserToken, rentId, file) {
  return (dispatch) => {
    dispatch(rentLldSendingAction());
    return RentsApiService.postRentEndInventory(authUserToken, rentId, file)
      .then(data => {
        dispatch(rentLldDownloadedAction(data));
        return data;
      }).catch(error => {
        dispatch(rentsLldFailedAction(error));
        dispatch(handleError(error));
        return error;
      });
  };
}

export function deleteRentEndInventory(authUserToken, rentId) {
  return (dispatch) => {
    dispatch(rentLldSendingAction());
    return RentsApiService.deleteRentEndInventory(authUserToken, rentId)
      .then(data => {
        dispatch(rentLldDownloadedAction(data));
        return data;
      }).catch(error => {
        dispatch(rentsLldFailedAction(error));
        dispatch(handleError(error));
        return error;
      });
  };
}


export function postRentBookStartInventory(authUserToken, rent, file) {
  return (dispatch) => {
    dispatch(rentLldSendingAction());
    return BooksApiService.postBookStartInventory(authUserToken, rent.book.id, file)
      .then(data => {
        dispatch(rentLldBookDownloadedAction(rent,data));
        return data;
      }).catch(error => {
        dispatch(rentsLldFailedAction(error));
        dispatch(handleError(error));
        return error;
      });
  };
}

export function deleteRentBookStartInventory(authUserToken, rent) {
  return (dispatch) => {
    dispatch(rentLldSendingAction());
    return BooksApiService.deleteBookStartInventory(authUserToken, rent.book.id)
      .then(data => {
        dispatch(rentLldBookDownloadedAction(rent,data));
        return data;
      }).catch(error => {
        dispatch(rentsLldFailedAction(error));
        dispatch(handleError(error));
        return error;
      });
  };
}



// WEBPACK FOOTER //
// ./src/store/rentsLld/actions.js